import React from 'react';
import { TextAreaProps } from 'antd/es/input';
import { StyledTextArea } from './InputStyles';

export type TTextAreaProps = TextAreaProps;

const TextArea = ({ value, ...props }: TTextAreaProps): JSX.Element => <StyledTextArea {...props} value={value} />;

export default TextArea;
